import styles from './table.module.scss';

// needs to match styles available in generate-flex-child-flex-prop-widths
export enum ColumnModEnums {
  CENTER = 'center',
  NO_OVERFLOW = 'no_overflow'
}

// Helper to build column class string
export const buildColumnClassString = ( { styles: colMod }: { styles?: ColumnModEnums | ColumnModEnums[] | undefined, width?: number } ): string => {
  let classStr = '';

  if( Array.isArray( colMod ) ) {
    colMod.forEach( el => {
      if( !el ) return;

      if( Array.isArray( el ) ) {
        el.forEach( ( em: ColumnModEnums ) => {
          classStr += ( classStr ? ' ' : '' ) + styles[em.toString()];
        } );
      } else {
        classStr += ( classStr ? ' ' : '' ) + styles[el.toString()];
      }
    } );
  } else {
    if( colMod ) classStr = styles[colMod];
  }

  return classStr;
};
